<template>
    <div class="page bgF5F5F5">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg lightGreyBottomBorder" style="line-height: 44px;">
                <div class="borderLayout paddingH16">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="$router.back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 44px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                            <router-link class="primaryTextColor bold" to="">链接</router-link>-->
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="paddingH20 white_bg">
            <div class="alignC " style="padding-top: 45px;">
                <img src="integral/success_yellow_circle_icon.png" width="48" height="48" alt=""/>
                <div class="orange font20r marginT16">
                    新人福利领取成功！
                </div>

                <router-link :to="{name : 'newPeopleLearnRequired', id : id}"
                     class="block learnButton centered marginT24 font14r">开始学习</router-link>
            </div>

            <div class="marginT20 font14r red">本福利限期{{dataItem ? dataItem.receiveTerm : '??'}}天内不学习或不下载就会过期，小主赶紧去学习吧！</div>

            <div class="marginT20">
                <bannerModule ref="bannerModule" version="4" categoryKey="RECRUIT_WEBAPP_POSTER_MODULE" />
            </div>

            <div>
                <!-- 找相关 -->
                <recommendInfoList :infoList="dataItem ? dataItem.interactionList : []"/>
            </div>

        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import externalApp from '@data/externalApp';
import orderBizTypeEnum from '@data/orderBizTypeEnum';

// modules
import bannerModule from '@/components/ad/bannerModule4';
import recommendInfoList from "@/components/contentModule/recommendInfoList";

// config
import appConfig from '../../appConfig';

// util
import appHelper from '@util/appHelper';
import routeHelper from "@util/routeHelper";

const config = {
    apiConfig : {
        get : {
            url : 'portal/welfare',
            params : {
                typeEnum : 'NEW_USER',
                showStatus : true
            }
        }
    }
};

export default {
    name: "newPeopleGiftReceiveSuccess",
    extends : shixunPagePart,
    components : { bannerModule, recommendInfoList },
    data () {
        return {
            title : '领取成功',
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,

            id : ''
        }
    },
    methods : {
        // onLoadDataItem() {
        //     if (typeof(this.dataItem) === 'string')
        //     {
        //         appHelper.showHint(this.dataItem);
        //     }
        // }
    },
    mounted() {
        this.id = routeHelper.getParam('id') || '';
    }
}
</script>

<style lang="scss" scoped>
.bannerLinkLayer {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.orange {
    color: #F4950E;
}
.red {
    color: #EE5555;
}
.learnButton {
    width: 282px;
    height: 34px;
    line-height: 34px;
    background: #F4950E;
    border-radius: 4px;
    border: none;
    color: white;
}
</style>
